module.exports = __webpack_public_path__ + "img/pic2.7cd2d055.svg";